import { useNavigate } from 'react-router-dom';
import styles from './BackButton.module.css';
import { FiArrowLeft } from 'react-icons/fi'; 

const BackButton = ({ to }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1); 
    }
  };

  return (
    <button className={styles.backButton} onClick={handleBack}>
      <FiArrowLeft className={styles.icon} />
      Back
    </button>
  );
};

export default BackButton;
